$(document).ready(function () {
	$.ajax({
		type: "GET",
		url: 'https://blog.podhax.com/wp-json/wp/v2/posts',
		dataType: 'JSON',
		success: function (data) {
			post1 = data[0]
			post2 = data[1]
//			$('#js_blog_post1_link').attr("href", post1.link)
			$('#js_blog_post1_img').attr("href", post1.link)
			$('#js_blog_post1_title').text(post1.title.rendered)
			$('#js_blog_post1_date').text(post1.date.split("T")[0])
			$('#js_blog_post1_img').attr("style", "background-image: url("+post1.jetpack_featured_media_url+");")

//			$('#js_blog_post2_link').attr("href", post2.link)
			$('#js_blog_post2_img').attr("href", post2.link)
			$('#js_blog_post2_title').text(post2.title.rendered)
			$('#js_blog_post2_date').text(post2.date.split("T")[0])
			$('#js_blog_post2_img').attr("style", "background-image: url("+post2.jetpack_featured_media_url+");")
		}
	});
});
